<template>
  <section>
    <Verein />
    <br>
    <Vorteil />
  </section>
</template>

<script>
  import Verein from '../components/verein'
  import Vorteil from '../components/vorteil'

  export default {
    components: {
      Verein,
      Vorteil
    }
  }
</script>
